export const emotionsBtn = [
  { title: 'Wow!', step: 90.18, type: 'wow', feedback: 1, path: 'wow/1' },
  { title: 'Happy', marginTop: 13, step: 69.53, type: 'happy', feedback: 2, path: 'happy/2' },
  { title: 'Normal', marginTop: 13, step: 48.87, type: 'normal', feedback: 3, path: 'normal/3' },
  { title: 'Sad', marginTop: 13, step: 27.89, type: 'sad', feedback: 4, path: 'sad/4' },
  { title: 'Terrible', marginTop: 13, step: 7.23, type: 'terrible', feedback: 5, path: 'terrible/5' },
]
